import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const BASENAME = import.meta.env.BASE_URL;

const FleetMaintenancesService = {
    apply: async (payload) => axios.post(API_URL + "/fleet-maintenances/apply", payload).then(({ data }) => data).catch((err) => { throw err }),

    damage: (id, dtStart, dtFinal) => `${BASENAME}reports/garrison_damage?v=${id}&dtinitial=${dtStart}&dtfinal=${dtFinal}`,

    maintenances: (id) => `${BASENAME}maintenances/form/${id}`,
};

export default FleetMaintenancesService;